import {
  Avatar,
  Card,
  Collapse,
  Descriptions,
  Space,
  Spin,
  Tag,
  Typography,
} from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FaRegUserCircle } from "react-icons/fa";
import ErrorLogout from "../../../helpers/ErrorLogout";
import { getSingleSurvey } from "../../../api/CommonRequest";
import BidList from "./BidList";
import { useNavigate } from "react-router-dom";
const { Title } = Typography;
const { Panel } = Collapse;
function SurveySingleView({ surveyID }) {
  const navigate = useNavigate();
  const [surveyDetails, setSurveyDetails] = useState(null);
  const [activeKey, setActiveKey] = useState(1);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const GetSurvey = async () => {
      try {
        setLoader(true);
        const { data } = await getSingleSurvey(surveyID);
        console.log(data, "data");

        if (data?.success) {
          setSurveyDetails(data.singleSurvey);
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);

        console.log(error);
        if (error?.response?.status === 401) {
          ErrorLogout(error);
        }
      }
    };
    GetSurvey();
  }, [surveyID]);
  return (
    <Spin spinning={loader}>
      return (
      <div className="flex-grow overflow-y-auto scrollbar-hide p-4 lg:p-6 md:p-5 bg-gray-50/30">
        <div className="max-w-7xl mx-auto space-y-6">
          {/* Header with Navigation and Status */}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 bg-white p-4 rounded-2xl border border-gray-100 shadow-sm">
            <div className="flex items-center gap-4">
              <button
                onClick={() => navigate("/survey-list")}
                className="w-10 h-10 flex items-center justify-center bg-gray-50 text-gray-600 rounded-xl hover:bg-gray-100 transition-all border border-gray-100"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6" /></svg>
              </button>
              <div>
                <h1 className="text-xl font-bold text-gray-800 flex items-center gap-2">
                  Survey Details
                  <span className="text-sm font-medium text-gray-400 bg-gray-50 px-2 py-0.5 rounded-lg border border-gray-100">
                    #{surveyDetails?._id?.slice(-8).toUpperCase() || "..."}
                  </span>
                </h1>
                <p className="text-xs text-gray-500 font-medium uppercase tracking-wider mt-0.5">
                  {surveyDetails?.clientName} • {moment(surveyDetails?.createdAt).format("DD MMM YYYY")}
                </p>
              </div>
            </div>

            <div className="flex items-center gap-3 w-full md:w-auto">
              <Tag
                className={`px-4 py-1.5 rounded-full font-bold text-sm border-none shadow-sm ${surveyDetails?.status === "active" ? "bg-green-100 text-green-700" :
                  surveyDetails?.status === "assigned" ? "bg-blue-100 text-blue-700" : "bg-orange-100 text-orange-700"
                  }`}
              >
                {surveyDetails?.status?.toUpperCase() || "LOADING..."}
              </Tag>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Main Content Areas */}
            <div className="lg:col-span-2 space-y-6">
              {/* Grid for Cards */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Client Information */}
                <Card className="rounded-2xl border-gray-100 shadow-sm overflow-hidden" bodyStyle={{ padding: 0 }}>
                  <div className="p-4 bg-blue-50/30 border-b border-gray-50">
                    <h3 className="text-sm font-bold text-gray-800 flex items-center gap-2">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1955EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
                      Client Information
                    </h3>
                  </div>
                  <div className="p-4 space-y-4">
                    <div>
                      <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Client Name</p>
                      <p className="text-sm font-semibold text-gray-800 mt-1">{surveyDetails?.clientName || "N/A"}</p>
                    </div>
                    <div>
                      <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Email Address</p>
                      <p className="text-sm font-semibold text-gray-800 mt-1">{surveyDetails?.clientEmail || "N/A"}</p>
                    </div>
                    <div className="grid grid-cols-2 gap-4 pt-2 border-t border-gray-50 mt-4">
                      <div>
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Primary Phone</p>
                        <p className="text-sm font-semibold text-gray-800 mt-1">{surveyDetails?.phonePrimary || "N/A"}</p>
                      </div>
                      <div>
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Secondary Phone</p>
                        <p className="text-sm font-semibold text-gray-800 mt-1">{surveyDetails?.phoneSecondary || "N/A"}</p>
                      </div>
                    </div>
                  </div>
                </Card>

                {/* Location Information */}
                <Card className="rounded-2xl border-gray-100 shadow-sm overflow-hidden" bodyStyle={{ padding: 0 }}>
                  <div className="p-4 bg-green-50/30 border-b border-gray-50">
                    <h3 className="text-sm font-bold text-gray-800 flex items-center gap-2">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" /></svg>
                      Location Information
                    </h3>
                  </div>
                  <div className="p-4 space-y-4">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">State</p>
                        <p className="text-sm font-semibold text-gray-800 mt-1">{surveyDetails?.state || "N/A"}</p>
                      </div>
                      <div>
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">City</p>
                        <p className="text-sm font-semibold text-gray-800 mt-1">{surveyDetails?.city || "N/A"}</p>
                      </div>
                    </div>
                    <div>
                      <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Address Full</p>
                      <p className="text-sm font-semibold text-gray-800 mt-1 leading-relaxed">{surveyDetails?.address || "N/A"}</p>
                    </div>
                    <div className="pt-2">
                      <a
                        href={surveyDetails?.locationUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center gap-2 py-2 w-full bg-green-50 text-green-700 rounded-xl font-bold text-xs hover:bg-green-100 transition-all border border-green-100 shadow-sm"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="m16 12-4-4-4 4" /><path d="M12 16V8" /></svg>
                        View on Maps
                      </a>
                    </div>
                  </div>
                </Card>
              </div>

              {/* Bid List Card */}
              {surveyDetails?.status === "assigned" && (
                <Card className="rounded-2xl border-gray-100 shadow-sm overflow-hidden" bodyStyle={{ padding: '1.5rem' }}>
                  <div className="flex justify-between items-center mb-6">
                    <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2">
                      <span className="w-1.5 h-6 bg-orange-400 rounded-full"></span>
                      Detailed Bid List
                    </h3>
                  </div>
                  <div className="pt-2">
                    <BidList surveyID={surveyID} />
                  </div>
                </Card>
              )}
            </div>

            {/* Right Column: Technicians & Meta */}
            <div className="space-y-6">
              {/* Survey Meta Information */}
              <Card className="rounded-2xl border-gray-100 shadow-sm overflow-hidden" bodyStyle={{ padding: 0 }}>
                <div className="p-4 bg-orange-50/30 border-b border-gray-50">
                  <h3 className="text-sm font-bold text-gray-800 flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="18" x="3" y="4" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
                    Timeline & Origin
                  </h3>
                </div>
                <div className="p-5 space-y-4">
                  <div className="flex items-center justify-between p-3 rounded-xl bg-orange-50/20 border border-orange-50">
                    <div className="flex items-center gap-3">
                      <div className="p-2 bg-white rounded-lg shadow-xs"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 22h14" /><path d="M5 2h14" /><path d="M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22" /><path d="M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2" /></svg></div>
                      <p className="text-xs font-bold text-gray-600">Start Date</p>
                    </div>
                    <p className="text-sm font-bold text-gray-800">{moment(surveyDetails?.startDate).format("DD MMM YYYY")}</p>
                  </div>

                  <div className="pt-2">
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-3">Survey Originator</p>
                    <div className="flex items-center gap-3 bg-gray-50/50 p-3 rounded-xl border border-gray-100">
                      <Avatar
                        src={surveyDetails?.createdBy?.profileImage}
                        icon={<FaRegUserCircle />}
                        className="bg-blue-100 ring-2 ring-white shadow-sm"
                        size={40}
                      />
                      <div>
                        <p className="text-sm font-bold text-gray-800">{surveyDetails?.createdBy?.name || "Admin"}</p>
                        <p className="text-[10px] font-bold text-[#1955EB] uppercase">Systems Admin</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>

              {/* Assigned Technicians */}
              {surveyDetails?.status === "assigned" && (
                <Card className="rounded-2xl border-gray-100 shadow-sm overflow-hidden" bodyStyle={{ padding: 0 }}>
                  <div className="p-4 bg-purple-50/30 border-b border-gray-50 flex justify-between items-center">
                    <h3 className="text-sm font-bold text-gray-800 flex items-center gap-2">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
                      Team Assigned
                    </h3>
                    <button
                      onClick={() => navigate("/survey-assign", { state: surveyDetails?._id })}
                      className="p-1.5 hover:bg-white rounded-lg transition-all text-[#1955EB]"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" /><path d="m15 5 4 4" /></svg>
                    </button>
                  </div>
                  <div className="p-4 space-y-4">
                    {surveyDetails?.assignTo.map((assignee, index) => (
                      <div key={index} className="space-y-3 p-3 rounded-xl border border-gray-100 bg-white shadow-xs">
                        <div className="flex items-center gap-3">
                          <Avatar
                            src={assignee?.surveyorId?.profileImage}
                            icon={<FaRegUserCircle />}
                            size={36}
                            className="ring-2 ring-purple-50"
                          />
                          <div className="flex-grow min-w-0">
                            <p className="text-sm font-bold text-gray-800 truncate">{assignee?.surveyorId?.name}</p>
                            <Tag className="m-0 text-[9px] px-2 py-0 h-4 border-none bg-green-50 text-green-600 font-bold uppercase">{assignee?.status}</Tag>
                          </div>
                        </div>
                        <div className="grid grid-cols-1 gap-2 border-t border-gray-50 pt-3">
                          <div className="flex justify-between items-center text-[10px]">
                            <span className="text-gray-400 font-bold uppercase">Assigned On</span>
                            <span className="text-gray-700 font-medium">{moment(assignee?.assignedDate).format("DD MMM YY")}</span>
                          </div>
                          <div className="bg-gray-50/50 p-2.5 rounded-lg">
                            <p className="text-[10px] font-bold text-gray-400 uppercase mb-1">Expert Instructions</p>
                            <p className="text-[11px] text-gray-600 leading-relaxed italic">
                              "{assignee?.instructions || "Perform standard survey checks promptly."}"
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </Card>
              )}
            </div>
          </div>
        </div>
      </div>
      );
    </Spin>
  );
}

export default SurveySingleView;
